const Mandotory = ({classes}) => {
    return ( 

        <span className={classes}>*</span>

     );
}
 
export default Mandotory;